import React from 'react';
import { runAction } from '../services/runAction';

/**
 * Botão de ação customizada para uso com react-jsonschema-form
 * @param {object} props
 * @returns {JSX.Element}
 */
export const ActionButtonWidget = ({ schema, disabled, formContext }) => {
  const action = schema?.properties?.action?.const || '';
  const btnColor = schema?.properties?.buttonType?.const || 'info';
  const btnText = schema?.properties?.buttonText?.const || 'Enviar';

  const handleClick = async () => {
    if (!action || disabled) return;
    try {
      console.log('antes de acionar', action)
      await runAction(action, formContext?.formData || {}, formContext?.config || {});
      console.log('✅ Ação executada:', action);
    } catch (err) {
      console.error('Erro ao executar ação:', err);
    }
  };

  return (
    <button
      className={`btn btn-${btnColor}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {disabled ? 'Aguarde...' : btnText}
    </button>
  );
};
